export const getFormmatedDate = (dateString: string) => {
  const _date = new Date(dateString);
  const yyyy = _date.getFullYear();
  let mm: any = _date.getMonth() + 1; // Months start at 0!
  let dd: any = _date.getDate();

  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;

  const formattedToday = mm + "/" + dd + "/" + yyyy;

  return formattedToday;
};

export const getFormmatedDateTime = (dateString: string, timeString: string) => {
  console.log('dateString: ', dateString)
  console.log('timeString: ', timeString)
  const _date = new Date(dateString);
  const yyyy = _date.getFullYear();
  let mm: any = _date.getMonth() + 1; // Months start at 0!
  let dd: any = _date.getDate();

  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;

  let output = mm + "/" + dd + "/" + yyyy;

  const _dateTime = new Date(timeString)

  if (_dateTime instanceof Date && !isNaN(_dateTime.getTime())) {
    console.log('timeString valid date: ', timeString)
    let hours: any = _dateTime.getHours();
    let minutes: any = _dateTime.getMinutes();
    let ampm: any = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    let strTime = hours + ':' + minutes + ' ' + ampm;
    output += ' ' + strTime
  } else if (timeString) {
    console.log('timeString invalid date: ', timeString)
    output += ' ' + timeString
  }

  return output
};

export const isValidTimeFormat = (time: string) => {
  const timeRegex = /^(0?[1-9]|1[0-2]):([0-5]\d)\s?(AM|PM)$/i;

  const match = time.match(timeRegex);

  if (match && match[1] && match[2] && match[3]) {
    const hours = parseInt(match[1], 10);
    const minutes = parseInt(match[2], 10);

    if ((hours >= 1 && hours <= 12) && (minutes >= 0 && minutes <= 59)) {
      return true;
    }
  }

  return false;
}


export const preprocessNodeForPdf = (node: Node) => {
  if (!node) return null;
  const clone = node.cloneNode(true);
  const walker = document.createTreeWalker(clone, NodeFilter.SHOW_TEXT, null);
  let textNode;
  while ((textNode = walker.nextNode())) {
    if (textNode.nodeValue && textNode.nodeValue.includes('\n')) {
      // Replace newline with <br>
      const lines = textNode.nodeValue.split(/\r?\n/);
      const frag = document.createDocumentFragment();
      lines.forEach((line, idx) => {
        frag.appendChild(document.createTextNode(line));
        if (idx < lines.length - 1) frag.appendChild(document.createElement('br'));
      });
      textNode?.parentNode?.replaceChild(frag, textNode);
    }
  }
  return clone;
}

export const formatMultiline = (text: string) => {
  if (!text) return null;
  let retText = "";
  text.split(/\r?\n/).map((line, idx, arr) => {
    console.log("line: ", line);
    retText += line;
    if (idx < arr.length - 1) {
      retText += "<br />";
    }
  });
  return retText;
};

export const getAngleBracketSignIfExists = (str: string) => {
  if (str.includes("<")) {
    return "<";
  } else if (str.includes(">")) {
    return ">";
  }
  return "";
};

export const parseNumberFromString = (str: string) => {
  const match = str.match(/\d+/);
  const _extracted = match ? Number(match[0]) : '-';

  console.log("I should not be called");

  const angleBracketSign = getAngleBracketSignIfExists(str);
  return _extracted === 2000 && angleBracketSign
    ? _extracted + 1
    : _extracted
}

export const getProperValueFromPoint = (_point: any) => {
  let angleBracketSign = '';

  console.log("type of _point: ", typeof (_point));


  if (typeof _point === 'string') {
    angleBracketSign = getAngleBracketSignIfExists(_point);
  }
  const _floatPoint = _point === '-'
    ? _point
    : (typeof _point) === "string"
      ? parseNumberFromString(_point)
      : parseFloat(_point)

  let _floatPointStr = _point === '-' ? _point : '';

  if (angleBracketSign.length > 0) {
    _floatPointStr =
      _floatPoint < 50
        ? "<50"
        : _floatPoint > 50 && _floatPoint < 100
          ? "<100"
          : _floatPoint > 2000
            ? '>2000'
            : _floatPoint
  }
  else {
    _floatPointStr = _floatPoint === '-' ? _floatPoint : isNaN(_floatPoint) ? '' : _floatPoint < 50 ? `<50` : _floatPoint > 2000 ? '>2000' : _floatPoint.toString();
  }
  if (_floatPoint === 50 || _floatPoint === 100 || _floatPoint === 2000) {
    _floatPointStr = angleBracketSign + _floatPointStr;
  }

  console.log("angleBracketSign: ", angleBracketSign);
  console.log('_floatPointStr: ', _floatPointStr)
  console.log('_point: ', _point)

  return _floatPointStr;
}